export default "__VITE_ASSET__CMZxbNkk__"